import { render, staticRenderFns } from "./rigid-joint.vue?vue&type=template&id=645ab8c6&scoped=true&"
import script from "./rigid-joint.js?vue&type=script&lang=js&"
export * from "./rigid-joint.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645ab8c6",
  null
  
)

export default component.exports